import Axios from 'axios';
import Api from '../../base/script/api';
import InputCountry from '../../core/input/country/input-country';
import UtmData from '../../base/script/utmData';
import recaptcha from '../../base/script/recaptcha';

require('../../assets/svg/whatsapp.svg');
require('../../assets/svg/telegram.svg');
require('../../assets/svg/sms.svg');
require('../../assets/svg/viber.svg');
require('../../assets/svg/phone.svg');

const formTemplate = require('./form-vue.pug');

export default function (content) {
  if (content) {
    return {
      template: formTemplate({
        data: content,
        className: content.className ? content.className : '',
        addClass: content.addClass ? content.addClass : '',
      }),
      props: ['hidden', 'id', 'expert', 'price', 'title', 'dataform'],
      data() {
        return {
          formComplete: false,
          showError: false,
          nameValid: true,
          formData: {
            type: 'call',
            phone: null,
            name: null,
            email: null,
            room_id: this.$props ? this.$props.id : null,
            expert: this.$props ? this.$props.expert : null,
            price: this.$props ? this.$props.price : null,
            title: this.$props ? this.$props.title : null,
            hidden: this.$props.hidden,
            second_name: '',
          },
          test: this.dataform,
        };
      },
      components: {
        InputCountry,
      },
      methods: {
        initCaptcha() {
          recaptcha.add(this.submitEl, (token) => {
            if (this.$el.querySelector('[name="g-recaptcha-response"]').value === token) {
              window.grecaptcha.execute();
              this.formData['g-recaptcha-response'] = token;
              this.sendForm();
            }
          });
        },
        getChange() {
          this.getType = this.formData.type;
          const classConnect = this.submitEl.className.match(/(?:^|\s)connect-(.*)(?!\S)/);
          if (this.getType) {
            if (classConnect) {
              this.submitEl.classList.remove(classConnect[0].trim());
              this.submitEl.classList.add(`connect-${this.getType}`);
            } else {
              this.submitEl.classList.add(`connect-${this.getType}`);
            }
          }
        },
        submit() {
          if (this.$parent.expert) this.formData.expert = this.$parent.expert.name;

          if (this.$parent.selectedAnswers) this.formData.quizes = this.$parent.selectedAnswers;
          let nameValid = true;
          if (this.nameValidation) {
            nameValid = this.formData.name && this.formData.name.length > 0;
          }
          if (nameValid && this.formComplete) {
            this.formSubmit();
          }
          this.showError = !this.formComplete;
          if (this.nameValidation) {
            this.nameValid = this.formData.name && this.formData.name.length > 0;
          }
        },
        validateField(e) {
          if (this.nameValidation) {
            this.nameValid = e.target.value.length > 0;
          }
        },
        completeForm(phone) {
          this.formComplete = true;
          this.formData.phone = phone;
        },
        acceptForm(value) {
          this.formComplete = false;
          if (value.length === 0) this.showError = false;
        },
        getPhonePrefix() {
          const phoneInput = this.$el.querySelector('input[data-phone-prefix]');
          if (phoneInput) {
            return `${phoneInput.getAttribute('data-phone-prefix')} `;
          }
          return '';
        },
        sendForm() {
          new UtmData(this.formData);
          // if (window.Comagic) {
          //   this.formData.comagic = window.Comagic.getCredentials();
          // }
          const copyObject = Object.assign({}, this.formData);
          copyObject.phone = `${this.getPhonePrefix()}${copyObject.phone}`;
          copyObject.stateless = window.stateless || 0;

          Axios.get(this.$el.action, {
            params: copyObject,
          })
            .then((response) => {
              const copyData = Object.assign({}, this.formData);
              const { data } = response;
              this.$el.reset();
              this.formData.phone = null;
              if (this.customPhone && this.customPhone.im) {
                this.formComplete = false;
                this.customPhone.im.updateValue();
              }
              if (this.formData.quiz) this.formData.quiz = null;
              if (this.formData.expert) this.formData.expert = null;
              if (this.formData.name) this.formData.name = null;
              if (this.formData.email) this.formData.email = null;
              if (this.nameValidation) {
                this.nameValid = true;
              }
              if (content.eventCategory && window.ga) {
                window.ga('send', {
                  hitType: 'event',
                  eventCategory: content.eventCategory,
                  eventAction: 'lead',
                  eventLabel: 'form',
                });
              }
              if (data.success) {
                if (copyData.type) { // отправка данных в comagic и chat
                  if (copyData.type === 'call' || copyData.type === 'cellphone') {
                    if (window.Comagic && window.Comagic.addOfflineRequest) {
                      window.Comagic.addOfflineRequest({
                        name: copyData.name || '',
                        phone: copyData.phone || '',
                      });
                    }
                  } else if (copyData.type === 'whatsapp') {
                    const chatData = {
                      url: window.location.href,
                      title: document.title,
                      channel: 'whatsapp',
                      Client_name: copyData.name,
                      phone: copyData.phone.replace(/\D/g, ''),
                    };
                    Api.post('https://api.chat2desk.com/webhooks/smart_script/MeCzLzE', chatData);
                  }
                }
                window.openSuccessPopup();
              }
            });
        },
      },
      computed: {
        isEmailValid() {
          return !this.$refs.emailInput || this.$refs.emailInput.checkValidity();
        },
      },
      mounted() {
        this.nameValidation = content.nameValidation === true;
        this.submitEl = this.$refs.submitBtn;
        this.initCaptcha();
        this.submitEl.classList.add(`connect-${this.formData.type}`);
        this.formSubmit = window.debounce(() => {
          if (window.captchaSitekey) {
            recaptcha.run(this.submitEl);
          } else {
            this.sendForm();
          }
        }, 200);
        this.customPhone = this.$el.querySelector('.form__phone input');

        const elements = [].slice.call(this.$el.querySelectorAll('.form__radio-label, .form__phone, .form__button'));
        if (elements) {
          elements.forEach((el) => {
            el.addEventListener('click', () => {
              this.$emit('clicked');
            });
          });
        }
      },
    };
  }

  return false;
}



// WEBPACK FOOTER //
// ./blocks/form/form.js